import * as React from "react";
import { FlatList, View, StyleSheet } from "react-native";

import EntryComponent from "./EntryComponent";

const GAP = 12;
const PADDING = 16;

export default class EntriesComponent extends React.PureComponent {
  state = { width: 0 };

  onLayout = event => {
    const width = Math.floor(event.nativeEvent.layout.width);
    if (width !== this.state.width) {
      this.setState({ width });
    }
  };

  // as many columns as fit, based on the icon size chosen in the settings
  columns() {
    const { company, listStatus } = this.props;
    let target = 140;
    if (listStatus === "Sales" && company) {
      target = company.smallSizeIcon ? 120 : company.mediumSizeIcon ? 150 : 180;
    }
    const inner = this.state.width - PADDING * 2;
    const count = Math.max(2, Math.floor((inner + GAP) / (target + GAP)));
    const size = Math.floor((inner - GAP * (count - 1)) / count);
    return { count, size };
  }

  _keyExtractor = (item, index) => String(index);

  render() {
    const { count, size } = this.columns();

    return (
      <View style={styles.container} onLayout={this.onLayout}>
        {this.state.width > 0 ? (
          <FlatList
            key={count}
            numColumns={count}
            data={this.props.data}
            extraData={size}
            keyExtractor={this._keyExtractor}
            contentContainerStyle={styles.content}
            renderItem={({ item, index }) => (
              <EntryComponent
                size={size}
                style={{
                  marginRight: (index + 1) % count === 0 ? 0 : GAP,
                  marginBottom: GAP,
                }}
                listStatus={this.props.listStatus}
                company={this.props.company}
                isCurrencyDisabled={this.props.isCurrencyDisabled}
                index={index}
                value={item}
                currency={this.props.currency}
                onPress={this.props.onPressItem}
                onLongPress={this.props.onLongPressItem}
                useDescription={this.props.useDescription}
              />
            )}
            onEndReachedThreshold={1}
            onEndReached={() => this.props.onEndReached()}
          />
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    padding: PADDING,
    paddingTop: 6,
  },
});
